module.exports = __webpack_public_path__ + "img/gaming-at-the-conference.c13597fc.png";